export interface InvoiceData {
  invoiceState: InvoiceState;
  invoiceUrl?: string;
}

export enum InvoiceState {
  NOT_AVAILABLE,
  AVAILABLE,
}
